import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import {
    Funnel, CloudUpload, UserRoundPlus, ChevronDown,
    Search,
    CalendarDays,
} from 'lucide-react';
import { Popover, Button, Modal } from "antd";


import Layout from "../../Layout";
import TableReport from "./components/TableReport";

export default function DebtReport() {
    const { t } = useTranslation();

    return (
        <Layout>
            <Helmet>
                <title>{t("page.debt")} | Khothi</title>
            </Helmet>

            {/* Header */}
            <div className="flex justify-between items-center mb-6 border-b border-gray-200 dark:border-gray-800 pb-2">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                    {t('debt.title')}
                </h2>
            </div>

            {/* TOOLBAR */}
            <div className="flex justify-end items-center px-4 py-3 bg-gray-50/50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 space-x-4">
                <div className="relative">
                </div>
                <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white font-medium">
                    <Funnel size={14} className="mr-1.5 text-gray-400" /> Bộ lọc
                </button>
                <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white font-medium">
                    <CloudUpload size={14} className="mr-1.5 text-gray-400" /> Export
                </button>
                <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white font-medium">
                    <UserRoundPlus size={14} className="mr-1.5 text-gray-400" /> Người xem
                </button>
            </div>

            <div className="py-4">
                <TableReport />
            </div>
        </Layout>
    )
}